"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultElementAnimation_1 = __importDefault(require("./defaultElementAnimation"));
const background_1 = require("../types/background");
const element_1 = require("../types/element");
function defaultBackgroundElement() {
    return {
        type: element_1.ELEMENT_TYPE.BACKGROUND,
        background: {
            type: background_1.ELEMENT_BACKGROUND_TYPE.COLOR,
            value: '#FFFFFF',
        },
        fillType: 1,
        stretch: '1',
        scale: 1,
        flipX: 1,
        flipY: 1,
        posX: 0,
        posY: 0,
        source: '',
        dynamic: false,
        startPoint: 0,
        loop: false,
        src: null,
        visible: true,
        id: (0, nanoid_1.nanoid)(8),
        left: 0,
        top: 0,
        width: 1920,
        height: 1080,
        file: {
            originalWidth: 681,
            originalHeight: 528,
            fileName: 'image_placeholder',
            videoDuration: 0,
        },
        active: false,
        playing: false,
        previewing: false,
        styles: {},
        animationsTimeline: [(0, defaultElementAnimation_1.default)()],
        animationCss: 'unset',
    };
}
exports.default = defaultBackgroundElement;
